<template>
	<div ref="content" class="content background2 searchBox3">
		<div class="userNavBox">
			<div class="navSearch2">
				<div class="searchBox-black">
					<label class="searchBox-label">客户名称</label>
					<div class="searchBox-condition" style="width: 150px">
						<!-- <el-form ref="form" :model="searchList" label-width="120px"> -->
							<!-- <el-form-item label="客户名称"> -->
								<el-input class="input-class el-input" v-model="searchList.customerId"></el-input>
							<!-- </el-form-item> -->
							<!-- </el-form> -->
						<!-- <el-select class="select-class" v-model="searchList.customerId" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select> -->
					</div>
				</div>
				<!-- <div class="searchBox-black">
					<label class="searchBox-label">所属区域</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchList.city" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="item in provinceList" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</div>
				</div> -->
				
				
				<div class="searchBox-black">
					<label class="searchBox-label">时间</label>
					<div class="searchBox-condition">
						<el-date-picker v-model="searchDate" type="daterange" range-separator="至" start-placeholder="开始日期"
						 end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>
				</div>
				<div class="searchButton" @click="search()">查询</div>
				<div class="searchBox-button">
					<label class="searchBox-label">报警类型</label>
					<div class="searchBox-condition">
						<el-checkbox-group v-model="checkList2">
							<el-checkbox v-for="item in RankList" :key="item.id" :label="item.id"  @change="checkList2(item.id)">
								{{item.name}}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<div class="navTable">
				<div class="tableTitle">
					<p class="title">详细内容</p>
					<ul>
						<li>
							<p class="cricle" style="background: #f48164"></p>
							<p class="des">传感器故障</p>
						</li>
						<li>
							<p class="cricle" style="background: #acd598"></p>
							<p class="des">主机掉电故障</p>
						</li>
						<li>
							<p class="cricle" style="background: #ffd328"></p>
							<p class="des">设备掉线</p>
						</li>
						<li>
							<p class="cricle" style="background: #4492fb"></p>
							<p class="des">传感器寿命到期</p>
						</li>
						<li>
							<p class="cricle" style="background: #58cbff"></p>
							<p class="des">维保将到期</p>
						</li>
						<li>
							<p class="cricle" style="background: #2bbc86"></p>
							<p class="des">探测器校准</p>
						</li>
						<li>
							<p class="cricle" style="background: #ff557f"></p>
							<p class="des">浓度超限</p>
						</li>
					</ul>
				</div>
				<div class="hichartBox">
					<p class="hichartTitle">该时间段总计图</p>
					<highcharts style="height: 280px;  width: 100%" :options="chart"></highcharts>
					
					<p class="hichartTitle">单日趋势图</p>
					<highcharts style="height: 260px; width: 100%" :options="chart2"></highcharts>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	import staListJs from "@/assets/js/sticList/stic.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				checkList2: [],
				searchDate: '',
				customerList: [],
				provinceList: [],
				RankList: [],
				chart2: {
					chart: {
						type: "column",
					},
					title: {
						text: "",
					},
					xAxis: {
						categories: [],
						crosshair: true,
					},
					
					credits: {
					          enabled:false
					},
					yAxis: {
						min: 0,
						title: {
							text: "数量（次）",
						},
					},
					tooltip: {
						// head + 每个 point + footer 拼接成完整的 table
						headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
						pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
							'<td style="padding:0"><b>{point.y} 次</b></td></tr>',
						footerFormat: "</table>",
						shared: true,
						useHTML: true,
					},
					plotOptions: {
						column: {
							borderWidth: 0,
						},
					},
					series: [],
				},
				chart: {
					chart: {
						plotBackgroundColor: null,
						plotBorderWidth: null,
						plotShadow: false,
						type: "pie",
					},
					lang: {
								noData: '暂无数据'
							},
					title: {
						text: "",
					},
					credits: {
					          enabled:false
					},
					legend: {
						align: "left",
						verticalAlign: "center",
						x: 0,
						y: 100,
						width: 300,
					},
					tooltip: {
						pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							cursor: "pointer",
							dataLabels: {
								enabled: false,
							},
							showInLegend: true,
						},
					},
					series: [{
						name: "占比",
						colorByPoint: true,
						data: [],
					}, ],
				},
				searchList: {
					customerId: '',
					time1: '',
					time2: '',
					district: '',
					city:'',
					alarmType: []
				},

			}
		},
		methods: {
			test(item){
				if(item.district != null){
					this.searchList.district=item.district;
				}else if(item==='all'){
					this.searchList.city='';
				}else{
					this.searchList.city=item;
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			search() {
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				this.searchList.alarmType = this.checkList2.join()
				var newParam = Object.assign(this.searchList);
				this.getFaultStatistics(newParam);
				this.getTimeQuantumStatistics(newParam);
				this.searchList.district='';
			},
			getUserBy() {
				staListJs.getCustomerName().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;
					let list = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						list.push({
							id: this.supportPersonList[i].id.toString(),
							name: this.supportPersonList[i].customerName,
						});
					}
					this.customerList = list;
				});
			},
			getaddr() {
				staListJs.getaddr().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;
					var array = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						array.push(this.supportPersonList[i].province);
					}
					var temp = [];
					var index = [];
					var l = array.length;
					for (var i = 0; i < l; i++) {
						for (var j = i + 1; j < l; j++) {
							if (array[i] === array[j]) {
								i++;
								j = i;
							}
						}
						temp.push(array[i]);
						index.push(i);
					}
					let list = [];
					for (var i = 0; i < temp.length; i++) {
						list.push({
							// id: this.provinceList[i].id.toString(),
							name: temp[i],
						});
					}
					this.provinceList = list;
				});
			},
			getRank() {
				staListJs.getRank().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;
					let list = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						list.push({
							id: this.supportPersonList[i].rank,
							name: this.supportPersonList[i].value,
						});
						this.checkList2.push(this.supportPersonList[i].rank)
					}
					this.RankList = list;
				});
			},
			getFaultStatistics(params) {
				staListJs.getFaultStatistics(params).then((response) => {
					const data = response.data;
					this.chart.series[0].data = [];
					for (var i = 0; i < data.data.length; i++) {
						this.chart.series[0].data.push({
							name: "",
							y: 0,
							color: "",
						});
					};
					for (var i = 0; i < data.data.length; i++) {
						this.chart.series[0].data[i].name = data.data[i].value+' '+data.data[i].y+'次';
						this.chart.series[0].data[i].y = data.data[i].y;
						switch (data.data[i].value) {
							case "传感器故障":
								this.chart.series[0].data[i].color = "#f48164";
								break;
							case "主机掉电故障":
								this.chart.series[0].data[i].color = "#acd598";
								break;
							case "设备掉线":
								this.chart.series[0].data[i].color = "#ffd328";
								break;
							case "传感器寿命到期":
								this.chart.series[0].data[i].color = "#4492fb";
								break;
							case "维保将到期":
								this.chart.series[0].data[i].color = "#58cbff";
								break;
							case "探测器校准":
								this.chart.series[0].data[i].color = "#2bbc86";
								break;
							case "浓度超限":
								this.chart.series[0].data[i].color = "#ff557f";
								break;
						}
					}
				});
			},
			getTimeQuantumStatistics(params) {
				staListJs.getTimeQuantumStatistics(params).then((response) => {
					const data = response.data;
					this.chart2.xAxis.categories = [];
					this.chart2.series = [];
					this.chart2.xAxis.categories = data.data[0].time;
					for (var i = 0; i < data.data[0].value.length; i++) {
						this.chart2.series.push({
							name: "",
							data: [],
							color: "",
						});
					};
					for (var j = 0; j < this.chart2.series.length; j++) {
						this.chart2.series[j].name = data.data[0].value[j];
						var a = new Array();
						for (var c = 0; c < this.chart2.xAxis.categories.length; c++) {
							a.push(data.data[c].y[j]);
						}
						this.chart2.series[j].data = a;
					}
					for (var i = 0; i <this.chart2.xAxis.categories.length; i++) {
						switch (this.chart2.series[i].name) {
							case "传感器故障":
								this.chart2.series[i].color = "#f48164";
								break;
							case "主机掉电故障":
								this.chart2.series[i].color = "#acd598";
								break;
							case "设备掉线":
								this.chart2.series[i].color = "#ffd328";
								break;
							case "传感器寿命到期":
								this.chart2.series[i].color = "#4492fb";
								break;
							case "维保将到期":
								this.chart2.series[i].color = "#58cbff";
								break;
							case "探测器校准":
								this.chart2.series[i].color = "#2bbc86";
								break;
							case "浓度超限":
								this.chart2.series[i].color = "#ff557f";
								break;
						}
					};
					
				});
			},
		},
		created() {
			
			var a=[]
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()-6)).toISOString().slice(0, 10));
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toISOString().slice(0, 10));
			this.searchDate=a
		},
		mounted() {
			this.getaddr();
			this.getRank();
			this.search();
			window.test=this.test;
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/statisticsList/alarmFrequency.vue